/**
 * @file routeElementsConfig.ts
 * @description Configuration file for managing route-specific element visibility and sideline labels.
 * This file defines which elements should be shown or hidden for each route in the application,
 * as well as the label to be displayed in the sideline for each route.
 */

/**
 * Interface defining the structure of the configuration for each route.
 */
interface RouteElementsConfig {
  [key: string]: {
    /** Selectors for elements to be hidden on this route */
    hide: string[];
    /** Selectors for elements to be shown on this route */
    show: string[];
    /** Optional label to be displayed in the sideline for this route */
    sidelineLabel?: string;
    /** Optional background style for the page */
    pageBackground?: string;
  };
}

/**
 * Array of selectors for all elements that can be toggled.
 * These are typically elements from the host WordPress site.
 */
const allElements = [
  "figure[id$='-hero']",
  ".entry-header",
  "#section-faq",
  "#section-chi-siamo",
  "#section-prova-ora",
  "#section-vuoi-piu-controllo",
];

/**
 * Configuration object defining the visibility of elements and sideline labels for each route.
 */
export const routeElementsConfig: RouteElementsConfig = {
  "/": {
    hide: [],
    show: allElements,
    sidelineLabel: "Genera contenuto",
  },
  "/genera-contenuto": {
    hide: allElements,
    show: [],
    sidelineLabel: "Genera contenuto",
  },
  "/contenuto/:id": {
    hide: allElements,
    show: [],
    sidelineLabel: "Genera contenuto",
  },
  "/archivio-contenuti": {
    hide: allElements,
    show: [],
    sidelineLabel: "Archivio contenuti",
    pageBackground: "#F3EDEC",
  },
  "/genera-piano": {
    hide: allElements,
    show: [],
    sidelineLabel: "Genera piano editoriale",
  },
  "/genera-piano/:id": {
    hide: allElements,
    show: [],
    sidelineLabel: "Rigenera piano editoriale",
  },
  "/piano/:id": {
    hide: allElements,
    show: [],
    sidelineLabel: "Piano editoriale",
  },
  "/archivio-piani": {
    hide: allElements,
    show: [],
    sidelineLabel: "Archivio piani editoriali",
    pageBackground: "#F3EDEC",
  },
  "/accedi": {
    hide: allElements,
    show: [],
  },
  "/registrati": {
    hide: allElements,
    show: [],
  },
  "/account": {
    hide: allElements,
    show: [],
    sidelineLabel: "Il tuo account",
    pageBackground: "#F3EDEC",
  },
  "/checkout": {
    hide: allElements,
    show: [],
  },
  "/faq": {
    hide: allElements,
    show: [],
    sidelineLabel: "FAQ",
    pageBackground: "#F3EDEC",
  },
};
